import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SQUAD, FULL_SQUAD } from "@/data/teamData";

export default function Squad() {
  return (
    <section id="skuad" data-testid="squad-section" className="bg-[#050B14] text-white relative overflow-hidden">
      {/* Decoration */}
      <div className="absolute top-20 right-0 w-1/2 h-px bg-gradient-to-r from-transparent to-[#E63946]/40" />
      <div className="absolute bottom-20 left-0 w-1/3 h-px bg-gradient-to-l from-transparent to-[#E63946]/40" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-24 relative z-10">
        <div className="mb-12 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">PUNGGAWA UTAMA</div>
            <h2 className="font-display text-5xl sm:text-6xl leading-none">
              SKUAD <span className="text-[#E63946]">RESMI</span>
            </h2>
            <p className="mt-4 text-white/70">
              Para pejuang yang siap melangkahkan kaki di setiap akhir pekan.
              Berbeda profesi, satu tujuan: kemenangan tim.
            </p>
          </div>
          <Link
            to="/skuad"
            data-testid="squad-view-all"
            className="inline-flex items-center gap-2 border border-white/30 hover:border-[#E63946] hover:text-[#E63946] px-5 py-3 text-xs font-bold tracking-wider transition-colors w-fit whitespace-nowrap"
          >
            LIHAT SEMUA ({FULL_SQUAD.length}) <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {SQUAD.map((p) => (
            <Link
              key={p.id}
              to={`/pemain/${p.id}`}
              data-testid={`squad-card-${p.id}`}
              className="group relative block bg-[#0A1128] border border-white/10 card-hover overflow-hidden"
            >
              <div className="aspect-[3/4] relative overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/40 to-transparent" />

                {/* Jersey number */}
                {p.num && (
                  <div className="absolute top-3 right-3 font-display text-4xl text-white/30 group-hover:text-[#E63946] transition-colors">
                    {p.num}
                  </div>
                )}
              </div>

              <div className="p-4 border-t border-white/10">
                <div className="font-display text-lg leading-tight">{p.name}</div>
                <div className="text-[10px] tracking-[0.2em] text-white/50 mt-1">{p.positionLabel || p.position}</div>
              </div>

              {/* Red corner */}
              <div className="absolute top-0 left-0 w-1 h-0 bg-[#E63946] group-hover:h-full transition-all duration-500" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
